import { render, staticRenderFns } from "./contextmenuGroup.vue?vue&type=template&id=bc948af4&scoped=true&"
import script from "./contextmenuGroup.vue?vue&type=script&lang=js&"
export * from "./contextmenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc948af4",
  null
  
)

export default component.exports